import {
  Avatar,
  Box,
  Stack,
  Typography,
  useTheme,
  SxProps,
} from "@mui/material";
import { getUserAvatarUrl } from "base/utils";

interface UserInformationProps {
  mainInfo: string | React.ReactNode | undefined;
  subInfo?: string;
  userInfo?: {
    cn: string | number | undefined;
    no: string | number | undefined;
  };
  content?: string;
  rightActions?: React.ReactNode;
  avatarContainerSx?: SxProps;
}

export const WIDTH_AVATAR = 30; 
const UserInformation: React.FC<UserInformationProps> = ({
  mainInfo,
  subInfo,
  content,
  rightActions,
  userInfo,
  avatarContainerSx,
}) => {
  const theme = useTheme();

  return (
    <Stack direction="row" alignItems="center" width="100%">
      <Box sx={{ alignSelf: "center", ...avatarContainerSx }}>
        <Avatar
          variant="circular"
          src={getUserAvatarUrl(userInfo?.cn || 0, userInfo?.no || 0)}
          sx={{ width: WIDTH_AVATAR, height: WIDTH_AVATAR }}
        >
          {mainInfo}
        </Avatar>
      </Box>
      <Box sx={{ ml: 1, width: "100%" }}>
        <Stack direction="row" justifyContent="space-between">
          <Box>
            {typeof mainInfo === "string" ? (
              <Typography>{mainInfo}</Typography>
            ) : (
              mainInfo
            )}
            <Typography sx={{ color: theme.palette.text.secondary }}>
              {subInfo}
            </Typography>
          </Box>
          {rightActions && <Box>{rightActions}</Box>}
        </Stack>
        {content && (
          <Typography dangerouslySetInnerHTML={{ __html: content }} />
        )}
      </Box>
    </Stack>
  );
};

export default UserInformation;
